// extracted by mini-css-extract-plugin
export default {"cardListWrapper":"style_cardListWrapper__BMb42"};